import React from "react";
import Chip from "./Chip";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
function Chips({ values, activeFilter, selectedFilter }) {
  return (
    <Stack direction="row" spacing={1}>
      {values.map((v) => (
        <Chip
          key={v.value}
          label={v.label}
          selected={v.value === activeFilter}
          onClick={() => selectedFilter(v)}
        />
      ))}
    </Stack>
  );
}

Chips.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ),
};
Chips.defaultProp = {
  values: [],
};
export default Chips;
